import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Moment from 'react-moment';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import OpenInNew from '@material-ui/icons/OpenInNew';

const styles = () => ({
  tile: {
    padding: 10,
    marginBottom: 10,
    backgroundColor: '#fafafa',
    position: 'relative',
    cursor: 'pointer',
  },
  tileHeading: {
    color: '#797979',
  },
  tileContent: {
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 1.5,
    color: '#394f5a',
    wordWrap: "break-word",
  },
  tileFooter: {
    color: '#797979',
    fontSize: 12,
  },
  icon: {
    fill: '#9e9e9e',
    width: 16,
    height: 16,
  },
  iconWrapperType: {
    position: 'absolute',
    bottom: 4,
    right: 4,
  },
});

class ReportCardsGroupTile extends React.Component {
  render() {
    const {
      t,
      classes,
      onDetailsButtonClick,
      data,
    } = this.props;

    return (
      <Paper
        elevation={1}
        className={`report-cards-group-tile ${classes.tile}`}
        onClick={onDetailsButtonClick.bind(this, data)}
      >
        <div className={classes.tileHeading}>
          <Moment format={dateFormat}>{data.start_date}</Moment>
          <span> - </span>
          <Moment format={dateFormat}>{data.end_date}</Moment>
        </div>
        <div className={classes.tileContent}>
          <p>
            <b>{t('Report type')}:</b>
            <br />
            {data.reason}
          </p>
          <p>
            <b>{t('Description')}:</b>
            <br />
            {data.description}
          </p>
        </div>
        <div className={classes.tileFooter}>
          <IconButton
            aria-label="Open"
            onClick={onDetailsButtonClick.bind(this, data)}
            className={`open-report-cards-details-button ${classes.iconWrapperType}`}
          >
            <OpenInNew className={classes.icon} />
          </IconButton>
        </div>
      </Paper>
    );
  }
}
export default withStyles(styles)(withSnackbar(withTranslation()(ReportCardsGroupTile)));

